/** Stock create/update field help copy (info tooltips). */
export const STOCK_FIELD_HELP = {
  category: "Main grouping (e.g., Medicine, Lab Supplies)",
  subCategory: "Specific product type",
  hsnSacCode: "Tax/HSN classification code",
  name: "Scientific name or search keywords",
  tradeName:
    "Brand name of the item along with product specifications (e.g., Nirlife Metronidozole Inj 100ml)",
  shortName:
    "Abbreviated display name. Will be displayed in prescription & billing. If its empty, it will fallback to trade name for display",
  ingredient: "Main chemical component",
  brand: "Manufacturer or brand or marketer label",
  nature: "Formulation (e.g., injection, oinment)",
  code: "Product barcode/SKU",
  purchaseUom:
    "Unit in which its normally purchased or a preferred unit in which its stored (e.g., Pcs, Box(es), etc)",
  adminUom: "Usage unit (e.g., ml/mg)",
  dosage:
    "Strength or dosage amount. These are indicative references used while administering",
  dosageType:
    "Dosage is approximated based on type: Fixed/Weight-Based/BSA (Body Surface Area)",
  reorderLevel: "Alerts you when stock falls below this quantity",
  reorderQty: "Recommended quantity to reorder when stock is low",
  thresholdUom: "Selling unit. Add multiple layers as necessary",
  drugSchedule: "Regulatory drug schedule",
  description: "Brief product details",
  cgst: "Central GST percentage",
  sgst: "State GST percentage",
  ndps: `Mark "Y" if it's a NDPS Drug`,
  autoConsumed:
    'Mark "Y" if inventory is not tracked based on actual consumption. It is deducted as a whole unit at the time of stock transfer/adjustment',
  billable: 'Mark "Y" if billable to client',
  // uomMapping: "Used when a product is sold in different UOMs",
  conversionFactor: "Conversion factor from Purchasee UOM to Sales UOM layer",
  salesUom: "Selling unit. Add multiple layers as necessary",
  allowedSale:
    'Mark "Yes" if the given UOM is billable in current branch. Default is set to "Yes"',
  batchNumber: "Unique ID or code stamped on a specific product",
  manufacturingDate: "The day the item was made or packaged",
  expiryDate: "The deadline after which the product shouldn't be sold or used",
  location: "The specific shelf, aisle, or room where the item is kept",
  quantity: "The exact physical count or amount of the item in stock",
  quantityUOM:
    "How the stock is counted (e.g., Bottle(s), Box(es), Pack(s)). Values will show based on whats added in UOM Mapping",
  unitSellingPrice: "The price a customer pays for a single unit",
  pricingUOM:
    "The unit used to set the price (e.g., charging per Box vs. per Piece)",
  landedCost:
    "Total cost to buy and deliver the item, including shipping and taxes. Auto-computed from purchases",
  groupName:
    "Groups similar items across brands for easy selection and reordering",
  skuId: "Unique code to identify this item",
  active: "Makes this item available for billing and patient records",
};
